import { render } from "./MentionsLegales.vue?vue&type=template&id=6cf3cab4&scoped=true"
import script from "./MentionsLegales.vue?vue&type=script&lang=js"
export * from "./MentionsLegales.vue?vue&type=script&lang=js"

import "./MentionsLegales.vue?vue&type=style&index=0&id=6cf3cab4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf3cab4"]])

export default __exports__